module.exports = __webpack_public_path__ + "img/vector_presession.cee93ddd.svg";